import { motion } from "framer-motion";
import "./App.css";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";

export default function Contact() {
  const form = useRef();
  const [popup, setPopup] = useState({ open: false, message: "" });

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm("service_su2up22", "template_unw8egq", form.current, "IwVnTNYM3MxQImhUz")
      .then(() => {
        setPopup({
          open: true,
          message: "Thank you for your interest, we will contact you shortly."
        });
        form.current.reset();
      }, (error) => {
        setPopup({
          open: true,
          message: `Looks like something went wrong.\n${error.text}\nPlease try again later.`
        });
      });
  };

  const closePopup = () => setPopup({ open: false, message: "" });

  return (
    <motion.section className="section card contact-section" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <div className="contact-wrap">
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p><strong>Address:</strong> 6 Caymus Street, Richmond Hill, Ontario, L4B 4G4</p>
          <p><strong>Email:</strong> info@bdrpconsulting.com</p>
          <p><strong>Phone:</strong> (416) 301-3347</p>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <label htmlFor="name">Name</label>
          <input id="name" name="name" type="text" required />

          <label htmlFor="email">Email</label>
          <input id="email" name="email" type="email" required />

          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" rows={5} required />

          <button type="submit">Send Message</button>
        </form>
      </div>
      {popup.open && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-modal card section" onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: 12, color: "#ff8800" }}>
              {popup.message.startsWith("Thank you") ? "Message Sent!" : "Error"}
            </h3>
            <p style={{ whiteSpace: "pre-line", marginBottom: 20 }}>{popup.message}</p>
            <button
              onClick={closePopup}
              className="popup-close-btn"
              style={{
                background: "#ff8800",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "10px 24px",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: 16,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </motion.section>
  );
}